/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { lazy, FC, useEffect, useState, useMemo } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { PrivateRoutes } from './PrivateRoutes';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { Logout, AuthPage } from '../modules/auth';
import { App } from '../App';
import request from '../../utils/request';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { changeIdentify } from '../../global/features/customerSlice';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import VerificationPage from '../pages/Auth/VerificationPage';
import { RootState } from '../../global/store';
import moment from "moment/moment";
import enAU from "date-fns/locale/en-AU";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

const GasSubscription = lazy(
	() => import('../pages/gas-subscription/GasSubscription')
);
const NewGasSubscription = lazy(
	() => import('../pages/gas-subscription/components/NewGasSubscription')
);
// const Profile = lazy(() => import('../pages/profile/Profile'));
const SubscriptionDetail = lazy(
	() => import('../pages/gas-subscription/components/SubscriptionDetail')
);

moment.locale('en', enAU);

const AppRoutes: FC = () => {
	const currentUser = Cookies.get('token') !== undefined ? true : false;
	const pelanggan = localStorage.getItem('pelanggan') || false;
	const dispatch = useDispatch();
	const dataCapel = useSelector((v: RootState) => v.customerReducer.identify);

	const onGetUserData = async (custNum: string | null = null, userId: string | null = null) => {
		if (custNum != null || userId != null) {
			await request
				.get(`/customer/identify?custNumber=${custNum}&userId=${userId}`)
				.then((res) => {
					if (res?.status === 200 || res?.status === 201) {
						const identifyData = res.data.data;
						let notifikasiLastSeen: any = {};
						try {
							notifikasiLastSeen = identifyData?.notifikasiLastSeen ? JSON.parse(identifyData.notifikasiLastSeen) : {};
						} catch (error) {
							console.log(error);
						}
						const newIdentify = {
							...identifyData,
							notifikasiLastSeen
						}

						dispatch(changeIdentify(newIdentify));
					}
				});

		}
	};

	const onGetAccountMapping = async (userId: string | null = null) => {
		if (!userId) return;
		await request.get(`/users/customernum/${userId}`).then((res) => {
			if (res?.data) {
				localStorage.setItem('customerNumbers', JSON.stringify(res.data));
			}
		});
	};

	useEffect(() => {
		onGetAccountMapping(localStorage.getItem('userId')).then();
		onGetUserData(localStorage.getItem('customerNum'), localStorage.getItem('userId')).then();
	}, []);

	return (
		<BrowserRouter basename={'/'}>
			<Routes>
				<Route element={<App />}>
					<Route path="error/*" element={<ErrorsPage />} />
					<Route path="logout" element={<Logout />} />
					{currentUser ? (
						<>
							{pelanggan == 'true' && dataCapel != null ? (
								<>
									<Route
										path="/*"
										element={<PrivateRoutes />}
									/>
									<Route
										index
										element={<Navigate to="/dashboard" />}
									/>
									{/* <Route path="auth/*" element={<AuthPage />} /> */}
								</>
							) : (
								<>
									{/* <Route path="auth/*" element={<AuthPage />} /> */}
									<Route element={<MasterLayout />}>
										{/* <Route
											path="/setting"
											element={<Profile />}
										/> */}
										<Route
											index
											element={
												<Navigate to="/gas-subscription/1" />
											}
										/>
										<Route
											path="/*"
											element={<GasSubscription />}
										/>
										<Route
											path="gas-subscription/:page"
											element={<GasSubscription />}
										/>
										<Route
											path="new-gas-subscription/*"
											element={<NewGasSubscription />}
										/>
										<Route
											path="subscription/:kid/:fid"
											element={<SubscriptionDetail />}
										/>
									</Route>
								</>
							)}
						</>
					) : (
						<>
							<Route path="auth/*" element={<AuthPage />} />
							<Route path="*" element={<Navigate to="/auth" />} />
						</>
					)}
					<Route
						path="verification/:token"
						element={<VerificationPage />}
					/>
				</Route>
			</Routes>
		</BrowserRouter>
	);
};

export { AppRoutes };
